@if (partner().code) {
<a class="marketing-module card" href="{{ partner().adUrl }}" target="_blank">
  <img class="marketing-module__img" src="/assets/img/{{ partner().adImage }}" width="768" height="512">
</a>
} @else {
<a class="marketing-module card" href="https://lakehouse-analytics.com/solutions/non-maturity-deposit-study/" target="_blank">
  <img class="marketing-module__img" src="/assets/img/lha-ad.png" width="768" height="512">
</a>
}
